export default "__VITE_ASSET__6bfbd980__"